module.exports = __webpack_public_path__ + "img/salted-creame.b5944675.png";